<template>
	<div class="bg-white px-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
		<div class="mb-2 mt-2 pt-3">
				<template>
					<el-form inline ref="form" :model="from" label-width="100px">
						<el-form-item :label="$t('payList.uid')" class="mb-0">
							<el-input size="small" v-model="from.name"></el-input>
						</el-form-item>
						<el-form-item :label="$t('model.yunAccount')" class="mb-0">
							<el-input size="small" v-model="from.username" ></el-input>
						</el-form-item>
						
						<!-- <el-form-item :label="$t('accountList.isFp')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
								<el-option :label="$t('accountList.yes')" :value="1"></el-option>
								<el-option :label="$t('accountList.no')" :value="0"></el-option>
							</el-select>
						</el-form-item> -->
						
						<!-- <el-form-item :label="$t('orderList.status')" class="mb-0">
							<el-select v-model="from.status" size="small" :placeholder="$t('system.select')">
								<el-option :label="$t('status.all')" :value="-1"></el-option>
							
								<el-option :label="$t('orderList.yes')" :value="1"></el-option>
								<el-option :label="$t('orderList.no')" :value="2"></el-option>
								
							</el-select>
						</el-form-item> -->
						<!-- <el-form-item :label="$t('accountList.cloudName')" class="mb-0">
							<el-select v-model="from.cloud_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item> -->
						
						<el-form-item :label="$t('model.agent')" class="mb-0">
							<el-select v-model="from.agent_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.agent" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						<el-form-item :label="$t('new1.sup')" class="mb-0">
							<el-select v-model="from.sup_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.sup" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item :label="$t('orderList.product')" class="mb-0">
							<el-select v-model="from.product_id" size="small" filterable :placeholder="$t('system.select')">
								<el-option  :label="$t('status.all')" :value="-1">
								</el-option>
								<el-option v-for="item in agentData.product" :key="item.id" :label="item.name" :value="item.id">
								</el-option>
							</el-select>
						</el-form-item>
						
						
						<el-form-item :label="$t('orderList.date')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time2"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
								  :picker-options="layout.pickerOptions"
							      >
							    </el-date-picker>
						</el-form-item>
						<el-form-item :label="$t('adminList.createTime')"  class="mb-0">
							 <el-date-picker
							      size="small"
							      v-model="from.time"
							      type="daterange"
							      align="right"
							      unlink-panels
								  value-format="yyyy-MM-dd"
							      :range-separator="$t('system.to')"
							      :start-placeholder="$t('system.startTime')"
							      :end-placeholder="$t('system.endTime')"
								  :picker-options="layout.pickerOptions"
							      >
							    </el-date-picker>
						</el-form-item>
						
						<el-form-item class="mb-0">
							<el-button type="info" @click="searchEvent" size="small">{{$t('system.search')}}</el-button>
							<el-button size="small" @click="clearSearch">{{$t('system.reset')}}</el-button>
						</el-form-item>
				
					</el-form>
					<div style="margin-top:10px">
						<el-button size="small" @click="openModel(false)" v-auth="'add'+auth_val" >{{$t('orderList.addOrder')}}</el-button>
						
						
						<el-tag class="ml-2" type="success">
						{{$t('orderList.total_money')+' '+ total_list.money}} $
						</el-tag>
						<el-tag class="ml-2">{{$t('orderList.total_order')+' '+ total_list.order_money}} $</el-tag>
						
					</div>
			</template>
		</div>

		<!-- 表格 -->
		<div class="mt-3 pt-2" style="padding-bottom:20px">
			<el-table stripe :data="tableData" style="width: 100%" @selection-change="handleSelectionChange" @expand-change="openTable">
				<!-- <el-table-column align="center" type="index" :label="$t('adminList.sort')" width="50">
				</el-table-column> -->
				
				<el-table-column  align="center" prop="id"  :label="$t('userList.id')" width="60">
				</el-table-column>
				
				
				 <el-table-column  type="expand" :label="$t('status.log')">
				      <template slot-scope="props">
				        <el-table v-loading="props.row.load" class="noth" stripe  :data="props.row.data" style="width: auto;padding-left: 60px;" @expand-change="openTable2">
							
							
							
							
							<el-table-column  type="expand" :label="$t('status.log')">
										     <template slot-scope="props2">
										       <el-table v-loading="props2.row.load" class="noth" stripe  :data="props2.row.data" style="width: 100%;padding-left: 48px;" >
																	
												<el-table-column align="center" width="140" prop="username" :label="$t('model.yunAccount')">
													<template slot-scope="scope">
														{{ props.row.username }}
													  </template>
													
												</el-table-column>
												
											
												
												<el-table-column width="100" align="center" prop="sup_name" :label="$t('new1.sup')">
													<template slot-scope="scope">
														{{ props.row.sup_name }}
													  </template>
												</el-table-column>
												
												
												<el-table-column align="center" width="140" prop="date" :label="$t('orderList.date')">
													<template slot-scope="scope">
														{{ props.row.date }}
													  </template>
												</el-table-column>
												
												
												
												
												
												<el-table-column align="center" width="100" prop="user_name" :label="$t('orderList.user')">
													<template slot-scope="scope">
														<el-link @click="layout.openUserInfo(props.row.uid)" type="primary" class="text_chengse">{{props.row.user_name}}</el-link>
														
													</template>
												</el-table-column>
							
							
							
							<el-table-column width="100" align="center" prop="pro_name" :label="$t('orderList.product')">
							</el-table-column>
												
												
												<el-table-column width="100" align="center" prop="log_type" :label="$t('orderList.logType')">
													<template slot-scope="scope">
														<span v-if="scope.row.log_type==1">{{$t('orderList.logType1')}}</span>
														<span v-if="scope.row.log_type==2">{{$t('orderList.logType2')}}</span>
													</template>
												</el-table-column>
							
							<el-table-column width="100" align="center" prop="order_money" :label="$t('orderList.order_money')">
													
							</el-table-column>
							
							
							<el-table-column width="100" align="center" prop="odds" :label="$t('orderList.odds')">
							</el-table-column>
							
							
							<el-table-column width="100" align="center" prop="money" :label="$t('orderList.money')">
								<template slot-scope="scope">
									<span class="text_chengse">{{scope.row.money}} </span>
								</template>
							</el-table-column>
							
									
							
							
							<el-table-column width="180" align="center" prop="order_no" :label="$t('orderList.order_no')">
							</el-table-column>
												
												
												<el-table-column width="100" align="center" prop="type" :label="$t('orderList.OrderType')">
													<template slot-scope="scope">
														<span v-if="props.row.type==1">{{$t('orderList.OrderType1')}}</span>
														<span v-if="props.row.type==2">{{$t('orderList.OrderType2')}}</span>
													</template>
												</el-table-column>
							
							
							
							
							<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
													<template slot-scope="scope">
														{{ props.row.create_time }}
													  </template>
							</el-table-column>
												
												<el-table-column align="center" width="100" prop="remark" :label="$t('orderList.remark')">
												</el-table-column>
												
												
												
												<el-table-column width="80"  prop="id" align="center" :label="$t('adminList.operation')">
													<template slot-scope="scope">
														<el-button-group>
														
															<el-button :disabled="layout.loading" :loading="layout.loading" v-if="scope.row.log_type==2" size="mini" plain type="danger" v-auth="'editAdmin'" @click="deleteItem(scope.row)">{{$t('system.delete')}}</el-button>
															
															<!-- <el-button :disabled="layout.loading" :loading="layout.loading"  size="mini" plain type="danger" v-auth="'editAdmin'" @click="deleteItem(scope.row)">{{$t('system.delete')}}</el-button> -->
														</el-button-group>
													</template>
												</el-table-column>
										       	
										     
										
										       </el-table>
										     </template>
										   </el-table-column>
							
							<el-table-column align="center" width="140" prop="username" :label="$t('model.yunAccount')">
								<template slot-scope="scope">
								    {{ props.row.username }}
								  </template>
								
							</el-table-column>
							
							<!-- <el-table-column width="100" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
								<template slot-scope="scope">
								    {{ props.row.cloud_name }}
								  </template>
							</el-table-column> -->
							
							
							<el-table-column width="100" align="center" prop="sup_name" :label="$t('new1.sup')">
								<template slot-scope="scope">
								    {{ props.row.sup_name }}
								  </template>
							</el-table-column>
							
							
							<el-table-column align="center" width="140" prop="date" :label="$t('orderList.date')">
								<template slot-scope="scope">
								    {{ props.row.date }}
								  </template>
							</el-table-column>
							
							
							
							
							
							<el-table-column align="center" width="100" prop="user_name" :label="$t('orderList.user')">
								<template slot-scope="scope">
									<el-link @click="layout.openUserInfo(props.row.uid)" type="primary" class="text_chengse">{{props.row.user_name}}</el-link>
									
								</template>
							</el-table-column>
				        	
				        	
				        	
				        	<el-table-column width="100" align="center" prop="pro_name" :label="$t('orderList.product')">
				        	</el-table-column>
				        	<el-table-column width="100" align="center" prop="log_type" :label="$t('orderList.logType')">
				        		<template slot-scope="scope">
				        			<span v-if="scope.row.log_type==1">{{$t('orderList.logType1')}}</span>
				        			<span v-if="scope.row.log_type==2">{{$t('orderList.logType2')}}</span>
				        		</template>
				        	</el-table-column>
				        	<el-table-column width="100" align="center" prop="order_money" :label="$t('orderList.order_money')">
							
				        	</el-table-column>
				        	
				        	
				        	<el-table-column width="100" align="center" prop="odds" :label="$t('orderList.odds')">
								
				        	</el-table-column>
				        	
				        	
				        	<el-table-column width="100" align="center" prop="money" :label="$t('orderList.money')">
				        		<template slot-scope="scope">
				        			<span class="text_chengse">{{scope.row.money}}</span>
				        		</template>
				        	</el-table-column>
				        	

				        	
				        	
				        	<el-table-column width="180" align="center" prop="order_no" :label="$t('orderList.order_no')">
				        	</el-table-column>
							
							
							<el-table-column width="100" align="center" prop="type" :label="$t('orderList.OrderType')">
								<template slot-scope="scope">
									<span v-if="props.row.type==1">{{$t('orderList.OrderType1')}}</span>
									<span v-if="props.row.type==2">{{$t('orderList.OrderType2')}}</span>
								</template>
							</el-table-column>
				        	
				        	
				        	
				        	
				        	<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
								<template slot-scope="scope">
								    {{ props.row.create_time }}
								  </template>
				        	</el-table-column>
							
							<el-table-column align="center" width="100" prop="remark" :label="$t('orderList.remark')">
							</el-table-column>
				        	
				      

				        </el-table>
				      </template>
				    </el-table-column>
				<!-- <el-table-column align="center" prop="name" width="50" :label="$t('adminList.avatar')">
					<template slot-scope="scope">
						<el-image 
							style="width: 40px; height: 40px"
							:src="scope.row.head" 
							:preview-src-list="check_img_list">
						</el-image>
					</template>
				</el-table-column> -->
				
				
				<el-table-column align="center" width="140" prop="username" :label="$t('model.yunAccount')">
				</el-table-column>
				
				
				
				
			<!-- 	<el-table-column width="100" align="center" prop="cloud_name" :label="$t('accountList.cloudName')">
				</el-table-column> -->
				
				
				<el-table-column width="100" align="center" prop="sup_name" :label="$t('new1.sup')">
				</el-table-column>
				
				
				<el-table-column align="center" width="140" prop="date" :label="$t('orderList.date')">
				</el-table-column>
				
				
				
				
				
				<el-table-column align="center" width="100" prop="user_name" :label="$t('orderList.user')">
					<template slot-scope="scope">
						<el-link @click="layout.openUserInfo(scope.row.uid)" type="primary" class="text_chengse">{{scope.row.user_name}}</el-link>
						
					</template>
				</el-table-column>
				
				<el-table-column width="100" align="center" prop="pro_name" :label="$t('orderList.product')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
					</template>
				</el-table-column>
				
				
				<el-table-column width="100" align="center" prop="log_type" :label="$t('orderList.logType')">
					<template slot-scope="scope">
						<span>{{$t('status.all')}}</span>
						
					</template>
				</el-table-column>
				
			
				
			
				
			<!-- 	<el-table-column align="center" prop="get_status" :label="$t('orderList.status')">
					<template slot-scope="scope">
						
						<span class="text-success" v-if="scope.row.status==1">{{$t('orderList.yes')}}</span>
						<span class="text-danger" v-if="scope.row.status==2">{{$t('orderList.no')}}</span>
					</template>
				</el-table-column> -->
				
				
				
				
			
			
				
				<el-table-column  width="100" align="center" prop="order_money" :label="$t('orderList.order_money')">
					
				
				</el-table-column>
				
				
				<el-table-column width="100" align="center" prop="odds" :label="$t('orderList.odds')">
					
				</el-table-column>
				
				
				<el-table-column  width="100" align="center" prop="money" :label="$t('orderList.money')">
					<template slot-scope="scope">
						<span class="text_chengse">{{scope.row.money}}</span>
					</template>
				</el-table-column>
				
				
				
				
				
				
				
				
				
				
				<el-table-column width="180" align="center" prop="order_no" :label="$t('orderList.order_no')">
				</el-table-column>
				
				
				<el-table-column width="100" align="center" prop="type" :label="$t('orderList.OrderType')">
					<template slot-scope="scope">
						<span v-if="scope.row.type==1">{{$t('orderList.OrderType1')}}</span>
						<span v-if="scope.row.type==2">{{$t('orderList.OrderType2')}}</span>
					</template>
				</el-table-column>
				
				
				<el-table-column align="center" width="180" prop="create_time" :label="$t('adminList.createTime')">
				</el-table-column>
				
				<el-table-column align="center" width="100" prop="remark" :label="$t('orderList.remark')">
				</el-table-column>
				
				
				
				
			
				
				
				
		
				<!-- <el-table-column width="80" fixed="right" prop="id" align="center" :label="$t('adminList.operation')">
					<template slot-scope="scope">
						<el-button-group>
						
							<el-button :disabled="scope.row.status==2" size="mini" plain type="primary" v-auth="'editAdmin'" @click="confirmChange(scope.row.id,2)">{{$t('orderList.xiao')}}</el-button>
							
						</el-button-group>
					</template>
				</el-table-column> -->
			</el-table>
		</div>



		<el-footer
		  class="d-flex border-top bg-white align-items-center px-0 position-fixed"
		  :style="{ bottom: '0', left: computedLeft, right: '0', zIndex: '100' }"
		  >
		   <div style="flex: 1;" class="px-2">
		    <el-pagination
		    :current-page="page.current"
		    :page-sizes="page.sizes"
		    :page-size="page.size"
		    @size-change="handleSizeChange"
		    @current-change="handleCurrentChange"
		    background
		    :layout="layout.is_phone ? 'total, prev, pager, next, jumper' : 'total, prev, pager, next, sizes, jumper'"
		    :total="page.total"
		    />
		   </div>
		  </el-footer>

		<el-dialog :close-on-click-modal="false"
			:title="editIndex > -1 ? $t('orderList.editOrder') : $t('orderList.addOrder')"
			:visible.sync="createModel"
			top="5vh"
			:width="layout.is_phone?'90%':'80%'"
			:append-to-body="true"
			custom-class="custom-dialog">
			<!-- 表单内容 -->
			<el-form style="max-height: 65vh; overflow: auto;" :rules="rules" ref="form" :model="form" :label-width="layout.is_phone?'80px':'100px'">
				<!-- <el-form-item :label="$t('adminList.avatar')" prop="icon">
					<el-upload
						name="file"
						class="avatar-uploader"
						action="/admin/image/uploadNew"
						:headers="{token:$store.state.user.token}"
						:data="{type:'userHead'}"
						:show-file-list="false"
						:on-success="handleAvatarSuccess"
						:before-upload="beforeAvatarUpload">
						<img v-if="form.icon" :src="form.icon" class="avatar">
						<i v-else class="el-icon-plus avatar-uploader-icon"></i>
					</el-upload>
				</el-form-item> -->
				
				
				<el-form-item :label="$t('orderList.OrderType')">
					<el-radio-group v-model="form.type" size="small">
						<el-radio :label="1" border>{{$t('orderList.OrderType1')}}</el-radio>
						<el-radio :disabled="true" :label="2" border>{{$t('orderList.OrderType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>
				
				
				
				
				<!-- <el-form-item :label="$t('accountList.cloudName')" prop="cloud_id">
					<el-select @change="changeCloud" :disabled="editIndex > -1" v-model="form.cloud_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in agentData.cloud" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				
				<el-form-item v-loading="layout.loading" v-if="form.cloud_id" :label="$t('model.yunAccount')" prop="account_id">
					<el-select @change="changeAccount" style="width: 85%;"  :disabled="editIndex > -1" v-model="form.account_id" size="small" filterable :placeholder="$t('system.select')">
					
						<el-option v-for="item in account" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
			
				
				
			
				<!-- <el-form-item :label="$t('adminList.belongTo')" prop="rule_id">
					<el-select v-model="form.rule_id" size="small" filterable :placeholder="$t('adminList.select')" style="width: 85%;">
						<el-option v-for="item in rule_list" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item> -->
				
				
				
				<el-form-item :label="$t('orderList.product')" prop="product_id">
					<el-select @change="selProduct" v-model="form.product_id" size="small" filterable :placeholder="$t('system.select')">
					
					</el-option>
						<el-option v-for="item in agentData.product" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				
				
				
				<el-form-item  :label="$t('orderList.logType')">
					<el-radio-group v-model="form.log_type" size="small">
						<el-radio :label="1" border>{{$t('orderList.logType1')}}</el-radio>
						<el-radio :label="2" border>{{$t('orderList.logType2')}}</el-radio>
					</el-radio-group>
				</el-form-item>

				
				<el-form-item  :label="form.log_type==1?$t('orderList.money'):$t('orderList.money2')" prop="money">
					<el-input v-model="form.money" type="number" :placeholder="form.log_type==1?$t('orderList.money'):$t('orderList.money2')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				
				
				<el-form-item v-if="form.log_type==1"  :label="$t('userList.odds')" prop="odds">
					<el-input   v-model="form.odds" type="number" :placeholder="$t('userList.odds')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
			
				
				<el-form-item  :label="$t('orderList.date')" prop="date">
					 <el-date-picker
					      v-model="form.date"
						  value-format="yyyy-MM-dd HH:mm:ss"
						  format="yyyy-MM-dd"
					      type="date"
					      :placeholder="$t('orderList.selDate')">
					    </el-date-picker>
				</el-form-item>
				
				
				<el-form-item  :label="$t('orderList.use_num')" prop="use_num">
					<el-input v-model="form.use_num" type="number" :placeholder="$t('orderList.use_num')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				<el-form-item  :label="$t('orderList.order_no')" prop="order_no">
					<el-input v-model="form.order_no" :placeholder="$t('orderList.order_no')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
			
				
				
				<el-form-item :label="$t('orderList.remark')" prop="remark">
					<el-input v-model="form.remark" :placeholder="$t('userList.remark')" clearable size="small" style="width: 85%;"></el-input>
				</el-form-item>
				
				
				
				
				
				
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="createModel = false">{{$t('adminList.cancel')}}</el-button>
				<el-button type="primary" @click="submit">{{$t('adminList.confirm')}}</el-button>
			</div>
		</el-dialog>

	</div>
</template>

<script>
	import { commondecrypt } from '@/main';
	import common from '@/common/mixins/common.js';
	import buttonSearch from '@/components/common/button-search.vue';
	import { mapState } from 'vuex';
	export default {
		components: {
			buttonSearch
		},
		inject: ['layout', 'app'],
		mixins: [common],
		data() {
			return {
				cloud_id:1,
				account:[],
				createModel: false,
				editIndex: -1,
				
				//搜索數据
				from: {
					name: '',
					username:'',
					status:-1,
					sup_id:-1,
					agent_id:-1,
					get_status:-1,
					product_id:-1,
					cloud_id:-1,
					time:[],
					time2:[],
				},
				auth_val: 'Order',

				preUrl: "data/orderList", //列表地址
				delAllUrl: "data/delOrderAll", //批量删除地址
				delUrl: "data/delOrder", //删除單条地址
				addUrl: "data/addOrder", //添加/修改地址
				editStatusUrl:"data/editStatusOrder",//修改狀態地址
				agentData:[],
				tableData: [],
				form: {},
				rules: {
					date: [{
						required: true,
						message: this.$t('orderList.selDate'),
						trigger: 'blur',
					}],
					money: [{
						required: true,
						message: this.$t('orderList.inpMoney'),
						trigger: 'blur',
					}],
					account_id: [{
						required: true,
						message: this.$t('orderList.selAccount'),
						trigger: 'blur'
					}],
					product_id: [{
						required: true,
						message: this.$t('orderList.selProduct'),
						trigger: 'blur'
					}],
					cloud_id: [{
						required: true,
						message: this.$t('accountList.selCloud'),
						trigger: 'blur',
					}],
					odds: [{
						required: true,
						message: this.$t('userList.inpOdds'),
						trigger: 'blur',
					}],
				},
				total_list:{},
				rule_list: [],
				check_img_list:[],
				zkLoad:false,
				is_odds:1
			}
		},
		watch: {
			refreshTrigger(newVal) {
				this.getList();    // 如果有其他需要刷新的方法
				this.layout.getPageNum();
			},
		},
		computed: {
			
			// 监听 Vuex state
			...mapState(['refreshTrigger']), // 监听 Vuex state
		},
		created() {
			this.commonList('account');
			this.commonList('orderAccount',this.cloud_id);
		},
		methods: {
			selProduct(e){
				console.log(e)
				let index = this.agentData.product.findIndex(item=>item.id==e)
				console.log(this.agentData.product[index])
				if(index != -1){
					this.is_odds = this.agentData.product[index].is_odds
				}else{
					this.is_odds = 1;
				}
			},
			openTable(row){
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/orderDetail', {
						id:row.id,
						type:1,
						product_id:this.from.product_id
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
				
			},
			
			openTable2(row){
				if(row.data.length==0){
					row.load  = true;
					this.axios.post('/admin/data/orderDetail', {
						id:row.id,
						type:2
					}, {
						token: true,
					}).then(res => {
						let all = res.data
						let list = all.data.list
						row.data = list
					
						row.load = false;
					}).catch(err => {
						// 失敗
						row.load  = false;
					})
				}
				
			},
			changeAccount(e){
				let index = this.account.findIndex(item=>item.id==e)
				this.form.odds = this.account[index].odds
			},
			confirmChange(id,type){
				let title = this.$t('orderList.confirmyes')
				if(type==2){
					 title = this.$t('orderList.confirmno')
				}
				this.$confirm(title, this.$t('system.prompt'), {
					confirmButtonText: this.$t('adminList.confirm'),
					cancelButtonText: this.$t('system.cancel'),
					type: 'warning'
				}).then(() => {
					this.layout.loading = true;
					let url = this.addOrEditUrl()
					this.axios.post(url, {
						id: id,
						type: type
					}, {
						token: true,
						loading: true
					}).then(res => {
				
						console.log(res)
						this.getList()
				
						this.layout.loading = false;
					}).catch(err => {
						this.layout.loading = false;
					})
				})
			},
			
			
			changeCloud(e){
				console.log(e)
				this.form.account_id = ''
				this.commonList('orderAccount',e);
			},
			getToUser(id){
				this.layout.getModel = true
				this.layout.getModelType = 1
				this.layout.getModelTypeId = id
			},
			checkLog(id){
				this.layout.logModel = true
				this.layout.logID = id
			},
			changePassShow(item){
				item.showPass = item.showPass==1?0:1
			},
			
			//提交
			submit() {
				// if (this.form.password != this.form.password2) {
				// 	this.$message({
				// 		message: this.$t('adminList.differentPasswords'),
				// 		type: 'error'
				// 	});
				// 	return
				// }
				this.$refs.form.validate(res => {
					// if(!this.form.headUrl){
					// 	this.$message.error(this.$t('adminList.upProfile'));
					// 	return false
					// }
					if (res) {
						//this.form.default = this.form.default.replace(/\n/g,',')
						this.form.id = this.editIndex
						this.addOrEdit(this.form,true)
						// 關閉模态框
					}
				})
			},

			// 打开模态框
			openModel(e = false) {
				const date = new Date();
				date.setTime(date.getTime() - 3600 * 1000 * 24);
				// 增加
				this.is_odds = 1
				console.log(e)
				if (!e) {
					// 初始化表單
					this.form = {
						order_no:'',
						id:0,
						type: 1,
						cloud_id: this.cloud_id,
						account_id:'',
						product_id:'',
						log_type:1,
						use_num:'',
						odds:'',
						
						money:'',
						date:date,
						remark:''
					}
					this.editIndex = -1
				} else {
					// 修改
					this.form = {
						id:e.id,
						cloud_id: e.cloud_id,
						focus:e.focus,
						username: e.username,
						password: e.password,
						product_id: e.product_id,
						log_type: e.log_type,
						use_num: e.use_num,
						status: e.status,
						money:e.money,
						money_type:e.money_type,
						remark:e.remark
					}
					this.editIndex = e.id
				}
				
				// 打开dialog
				this.createModel = true
			},
			//公共列表
			commonList(type,id=0) {
				this.account = [];
				this.layout.loading = true;
				this.axios.post('/admin/user/commonList', {
					type: type,
					id:id
				}, {
					token: true,
				}).then(res => {
					let all = res.data
					let list = all.data.list
					if(type=='account'){
						this.agentData = list
					}else{
						//console.log(list)
						this.account = list.account
					}
					

					this.layout.loading = false;
				}).catch(err => {
					// 失敗
					this.layout.loading = false;
				})
			},
			handleAvatarSuccess(res, file) {
				this.form.icon = URL.createObjectURL(file.raw);
				let en_data = commondecrypt(res.encryption)
				res.encryption = JSON.parse(en_data)
				if(res.encryption.code==1){
					this.form.headUrl = res.encryption.data.list.url
				}
			  },
			beforeAvatarUpload(file) {
							const isJPG = file.type === 'image/jpeg';
							const isLt2M = file.size / 1024 / 1024 < 2;
					
							// if (!isJPG) {
							//   this.$message.error('上傳头像图片只能是 JPG 格式!');
							// }
							// if (!isLt2M) {
							//   this.$message.error('上傳头像图片大小不能超過 2MB!');
							// }
							return isJPG && isLt2M;
			},
			//前往修改页面
			editItem(obj) {
				this.$router.push({
					name: 'set_manager_rule',
					query: {
						item: obj
					}
				})
			},
			getListResult(e) {
				console.log(e)
				this.tableData = e.list
				this.total_list = e.total_list
				this.check_img_list = e.list.map(item=>{
					return item.head
				})
			},
			// 清空篩選條件
			clearSearch() {
				this.from = {
					name: '',
					username:'',
					status:-1,
					sup_id:-1,
					agent_id:-1,
					get_status:-1,
					product_id:-1,
					cloud_id:-1,
					time:[],
					time2:[],
				}
			
				//this.$refs.buttonSearch.closeSuperSearch()
				this.search = ''
				this.getList()
			},
			// 選擇图片
			chooseImage() {
				this.app.chooseImage((res) => {
					//console.log(res)
					//this.form.headUrl = ''
					this.$set(this.form, 'headUrl', res[0].url);
					this.form['headId'] = res[0].id
					this.$set(this.form, 'headId', res[0].id);
					//this.form.headUrl = res[0].url
				}, 1)
			}
		}
	}
</script>

<style>
.custom-dialog {

  z-index: 3000!important; /* 设置更高的 z-index */
}
</style>
